import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const TimorLesteFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16036'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16036)'>
				<rect
					width='20'
					height='14'
					fill='#FF323E'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0L12.381 7L0 14V0Z'
					fill='#FFCC51'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0L8.57143 7L0 14V0Z'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.2454 7.57712L3.61377 8.93439L3.28389 7.47808L1.77152 7.3088L3.08288 6.55132L2.77982 5.08943L3.92016 6.07759L5.24522 5.34337L4.63863 6.71157L5.76063 7.71969L4.2454 7.57712Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default TimorLesteFlagIcon;
